<p-card styleClass="flex w-full h-full p-4">
  <ng-template pTemplate="header">
    <h2>My Consulting</h2>
  </ng-template>
  <app-my-consulting class="flex w-full" [staffId]="staffId"></app-my-consulting>
</p-card> 